export default "__VITE_ASSET__CccT9ZgO__"